import React, { useState, useEffect } from 'react';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { studentCheckLogin } from '../newMain/studentMain';
import './resources.css'
import tag1 from '../../public/img/tag/tag1.png';
import $ from 'jquery';

const StudentResourcesContext = () => {

    const [resource,setResource] = useState({})
    const [documentFileList, setDocumentFileList] = useState([]);
    const resourcesId = localStorage.getItem(Config.tokenPrefix + 'resourceId');

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        search(resourcesId);
    }, []);

    //查询
    const search = (resourceId) => {
        Base.callBackApi("resource/searchById", {'resourceId': resourceId}).then((data) => {
            const resource = data.object
            let displayContent = resource &&resource?.displayContent?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
            // 处理图片
            if(displayContent) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = displayContent;
                var images = tempDiv.getElementsByTagName('img');
                for (var i = 0; i < images.length; i++) {
                    var img = images[i];
                    var src = img.getAttribute('src');
                    var index = src.indexOf(Config.imgServer);
                    if (index !== -1) {
                        var newSrc = src + '?' + Config.sasToken;
                        img.setAttribute('src', newSrc);
                    }
                }
                displayContent = tempDiv.innerHTML;
            }
            $("#displayContent").empty().append(displayContent);
            setDocumentFileList(
                (resource && resource.resourceAnnexModelList?.length) 
                ? resource.resourceAnnexModelList.map(item => {
                    return {
                        uid: item.resourceAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.resourceFiles + item.storagePath
                    };
                })
                : []
            );
            setResource(resource)
        }).catch(err => { }).finally(() => { });
    }
    
    const downloadFile = (item) => {
        if (!Base.stopClick()){
            return;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (item.lastModified || isLoad) {
        //     return;
        // }
        // setIsLoad(true);
        // item.code = "RESOURCE_PATH";
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             message.error(data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => ({ err })).finally(() => {
        //     setIsLoad(false)
        // });
    }

    return (
        <div id="container" className="websiteTemplate studentResources">
            {/* 提示信息弹框 */}
            <div className='title'>
                <div>{resource.resourcePageName}</div>
            </div>
            
            <div className='websiteDisplayContent' hidden={$("#displayContent").html()=="" } >
                <div id="displayContent" className='displayContent' ></div>
            </div>
            
            
            {documentFileList.length !== 0 &&
                <div>
                    <div className='label'  style={{color:'#000' ,margin:'10px 0px'}}>
                        Attachment
                    </div>
                    <div className='uploadFile' style={{ marginTop: '-5px' }}>

                        {documentFileList.map((item, index) =>
                            <div className='upload' key={index} title={item.name} style={{ display: 'flex' }}>
                                <div className="uploadFileRow" >
                                    <img src={tag1} className="tagImg"></img>
                                    <div onClick={() => downloadFile(item)} className='fileBox'>{item.name}</div>
                                </div>
                            </div>
                        )
                        }

                    </div>
                </div>
            }
        </div>
    )
}

export default StudentResourcesContext;